<div
    class="ds-checkbox"
    [ngClass]="[
        'ds-checkbox--' + size,
        isDisabled ? 'ds-checkbox--disabled' : '',
        value ? 'ds-checkbox--checked' : '',
        subtitle ? 'ds-checkbox--with-subtitle' : '',
    ]"
    [attr.tabindex]="isDisabled ? -1 : 0"
    (click)="onWrapperToggle($event)"
    (keyup.enter)="onWrapperToggle($event)"
    (keyup.space)="onWrapperToggle($event)"
>
    <mat-checkbox
        class="ds-checkbox__item"
        [checked]="value"
        [disabled]="isDisabled"
        [disableRipple]="true"
        (change)="onCheckboxChange($event)"
    >
        <ng-container *ngIf="label; else projectedLabel">{{ label }}</ng-container>

        <ng-template #projectedLabel>
            <ng-content></ng-content>
        </ng-template>
    </mat-checkbox>

    <p *ngIf="subtitle" class="ds-checkbox__subtitle">{{ subtitle }}</p>
</div>
